import * as React from 'react'
import { useCallback, useEffect, useRef, useState, CSSProperties } from 'react';
import { render } from 'react-dom'
import Frame from './component/frame/Frame';
import { FrameDefines } from './component/frame/IFrame';
import './index.scss';
import { ChatItemDefines } from './component/chatItem/IChatItem';
import { ColorDefines } from './interface/IColors';
import { initializeUtil } from './util/initializeUtil';

enum ChatformCustomEvent {
  INIT = "chatform-init",
  BEFORE_NEXT_STEP = "chatform-beforenextstep",
}

const root = document.getElementById('chatform-root');
const App = () => {
  const [dispatchCallTime, setDispatchCallTime] = useState<number>();
  const [initData, setInitData] = useState<FrameDefines>();
  const [colors, setColors] = useState<ColorDefines>();
  const [style, setStyle] = useState<CSSProperties>({});
  const ref = useRef<HTMLDivElement|null>(null);
  
  const setInitializeData = (data: FrameDefines) => {
    setInitData(data);
  };

  const setColorData = (data: ColorDefines) => {
    setColors(data);
  };

  useEffect(() => {
    if (!colors) return;
    setStyle({
      color: colors.font
    });
  }, [colors]);

  const setInitDataFunction = useCallback(() => {
    if (initData != null) return;
    const event = new CustomEvent(ChatformCustomEvent.INIT,
      { detail: {
        setInitializeData, setColorData, initializeUtil
      }, bubbles: true });
    ref.current.dispatchEvent(event);
  }, [initData]);

  useEffect(() => {
    if (initData) return () => {};
    setInitDataFunction();
    const timeoutId = setTimeout(() => setDispatchCallTime(Date.now()), 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [dispatchCallTime, initData]);

  useEffect(() => {
    if (ref.current) {
      setDispatchCallTime(Date.now());
    }
  }, [ref.current]);

  const onBeforeNextStep = useCallback((e: {step: number, chatItem: ChatItemDefines}) => {
    if (ref.current) {
      const event = new CustomEvent(ChatformCustomEvent.BEFORE_NEXT_STEP, {detail: e, bubbles: true})
      ref.current.dispatchEvent(event);
    }
  }, [ref.current]);

  return (
    <div id="chatform" className="index" ref={ref} style={style}>
      {initData &&
        <Frame
          onBeforeNextStep={onBeforeNextStep}
          expanded={initData.expanded}
          direction={initData.direction}
          position={initData.position}
          toggle={initData.toggle}
          main={initData.main}
          colors={colors}
        />
      }
    </div>
  );
};

render(<App />, root);
